import { Fragment, useMemo } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import HeaderCard from "../../../Components/Common/Component/HeaderCard";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import DataTable from "../../Components/DataTable"; 
import { createColumnHelper } from "@tanstack/react-table";

export const SupportList = () => {
   const { getData } = useDataFetch();
  
    const { data, isLoading } = getData(
      ["support"],
      "/support/all/dashboard/admin",
      {
        enabled: true,
      }
    );
      
  

    
  const columnHelper = createColumnHelper();

 const columns = useMemo(() => [
    columnHelper.display({
        id: "usuario",
        header: "Usuario",
        cell: props => {
        const row = props.row.original;
        return (
            <>
            <img
                className="me-75"
                src={`/users/show/photo/${row.user_id.photo || ""}`}
                alt="usuario"
                height="30"
                width="30"
            />
            <span>{row.user_id.name}</span>
            </>
        );
        }
    }),
    columnHelper.accessor("issue", {
        header: "Asunto",
    }),
    columnHelper.accessor("topic", {
        header: "Tema",
    }),
    columnHelper.accessor("comment", {
        header: "Comentario",
    }),
    columnHelper.display({
        id: "estado",
        header: "Estado",
        cell: props => {
        const state = props.row.original.state;
        const badge = {
            PENDING: <span className="badge bg-secondary">Pendiente</span>,
            ANSWERED: <span className="badge bg-primary">Contestado</span>,
            RESOLVED: <span className="badge bg-success">Resuelto</span>,
            CANCELLED: <span className="badge bg-dark">Cancelado</span>,
        };
        return badge[state] || <span className="badge bg-light">Desconocido</span>;
        }
    }),
    columnHelper.display({
        id: "acciones",
        header: "Acciones",
        cell: props => {
        const row = props.row.original;
        const isDisabled = row.state === "RESOLVED" || row.state === "CANCELLED";

        return (
           <></>
        );
        }
    })
    ], [columnHelper]);

    
  return (
    <Fragment>
      <Breadcrumbs  title="Soportes" mainTitle="Soportes" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <HeaderCard title="Soportes" />
              <CardBody>
                  <DataTable data={data?.data?.supports??[]} progressPending={isLoading} columns={columns} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}